
import { Box, Text, Flex, Heading, For, Image, Link, Stack } from "@chakra-ui/react";
import { HeaderDated, TheContent } from "@/components/partials/Helpers";
import { LuMoveRight } from "react-icons/lu"
import ShadowBox from "@/components/partials/ShadowBox";
import Advertising from '@/components/Advertising';
import HomeColumnists from '@/components/HomeColumnists';
import Shorts from '@/components/Shorts';

export default async function HomePosts({ isCatList = false, slug = '', posts, ads }) {

  function adsByindex(ads, k) {
    const i = k + 1;
    const index = i.toString();

    const hasAds = ads.find(a => a.position === index);
    return hasAds || {}
  }

  function thumbImages(postImages, postTitle, isMainBox) {
    const box = isMainBox ? 'box' : 'box2';

    if(!postImages) return;

    const image = postImages.find(i => i.mediaTyped === box);

    if(!image) return;

     return (
        <Image
          src={ image.mediaCdnUrl }
          alt={ postTitle }
          objectFit="cover"
          w="100%"
          h="100%"
          display="block"
          position="absolute"
          top="0"
          left="0"
          z-index="1"
        />
    )
  }

  function theBox(item, flexDirection, hasContent = false, isMainBox = false) {
    return (
      <Flex as={Link} href={item.postPermalink} rounded="xl" border="2px solid" borderColor="gray.50" overflow="hidden" h="100%" alignItems="flex-start">
        <Flex w="100%" flexDirection={{ base: 'column', lg: flexDirection }} borderBottomWidth={isMainBox ? '1px' : ''} borderColor="gray.100">
          <Box flex={{base: 'none', lg: isMainBox ? '40%' : 'none'}} w="100%" h={{base: '180px', lg: isMainBox ? 'auto' : '180px'}} position="relative">
            { thumbImages(item.postImages, item.postTitle, isMainBox) }
          </Box>

          <Flex flex="60%" flexDirection="column" justifyContent="space-between" p={isMainBox ? '6' : '6'}>
            <Box py={{ base: '4', lg: '0' }}>
              <Heading as="h2" fontFamily="inherit" fontSize={isMainBox ? '1.6em' : '1.6em'} fontWeight="300" lineHeight="1">
                { item.postTitle }
              </Heading>

              <Box fontSize="1em" lineHeight="1.2em" fontWeight="300" py={{ base: '4', lg: '6' }}>
                <TheContent body={item.postCall} />
              </Box>

              <Box fontWeight="300" textTransform="uppercase" fontSize="0.7em">
                <HeaderDated date={item.createdAt} />
              </Box>

              <Flex textTransform="uppercase" fontSize="0.8em" alignItems="center" color="blue.600" pt={{ base: '4', lg: '6' }}>
                <Text mr="2">Ver Detalhes</Text>
                <LuMoveRight />
              </Flex>
            </Box>
          </Flex>
        </Flex>
      </Flex>
    )
  }

  return (
    <Box>
      <Stack gap="8">
        <For each={posts}>
          {(item, k1) => (
            <Box key={k1}>
              <Stack gap="8">
                { isCatList === false && (
                  <Advertising ads={adsByindex(ads, k1)} />
                )}

                <ShadowBox text={ isCatList === false || (isCatList === true && k1 === 0) ? item.catName : '' } key={k1}>
                  <Box>
                    { theBox(item.posts[0], 'row', true, true) }
                  </Box>

                  <Flex flexDirection={{ base: 'column', lg: 'row' }}  flexWrap="wrap" gap="4" mt="4">
                    <For each={item.posts}>
                      {(post, k) =>

                        k > 0 && (

                            <Box flex="1 0 48%" key={k}>
                              { theBox(post, 'column', false, false) }
                            </Box>

                        )

                      }
                    </For>
                  </Flex>
                </ShadowBox>

                { isCatList === true && (
                  <Advertising ads={adsByindex(ads, k1)} />
                )}

                { k1 ===0 && isCatList === false && (
                  <>
                  <HomeColumnists />

                  <Shorts />
                  </>
                )}
              </Stack>
            </Box>
          )}
        </For>
      </Stack>
    </Box>
  )
}
